import { Link } from 'react-router-dom';
import { simbaStyled, colors } from '@naf-simba/theme';

export const LinkWrapper = simbaStyled(Link)(({ theme }) => ({
  gridColumn: 'auto / span 6',
  display: 'flex',
  alignItems: 'center',
  maxWidth: '448px',
  textDecoration: 'none',
  borderBottom: `1px solid ${colors.common.grey[200]}`,

  '& > h3': {
    marginLeft: theme.spacing('l'),
    marginRight: 'auto',
  },

  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    maxWidth: '100%',
    gridColumn: 'auto / span 12',
  },
}));
